import { Box, MenuItem, Select, SelectChangeEvent, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetLanguagesQuery } from "features/api/apiSlice";
import { useEffect, useMemo } from "react";

const DEFAULT_LANG = "en-GB";

const LanguageSelector = () => {
    const { i18n } = useTranslation();
    const { data: languages } = useGetLanguagesQuery();

    const currentLang = useMemo(() => {
        if (!languages) return DEFAULT_LANG;

        if (languages.some(lang => lang.isoCode === i18n.language)) {
            return i18n.language;
        }

        const partialMatch = languages.find(lang => i18n.language.startsWith(lang.isoCode!!.split("-")[0]))?.isoCode;

        return partialMatch || DEFAULT_LANG;
    }, [i18n.language, languages]);

    useEffect(() => {
        if (languages && currentLang !== i18n.language) {
            i18n.changeLanguage(currentLang);
        }
    }, [languages, currentLang, i18n]);

    const handleLanguageChange = (event: SelectChangeEvent) => {
        i18n.changeLanguage(event.target.value);
    };

    return languages ? (
        <Select size="small" variant="outlined" value={i18n.language} onChange={handleLanguageChange} sx={{ width: "140px", flexShrink: 0 }}>
            {languages?.map((language) => {
                return (
                    <MenuItem value={language.isoCode} key={language.isoCode} >
                        <Stack direction="row" spacing={2}>
                            <Box component='img' src={`/images/flags/${language.flagIconCode}.svg`} maxWidth={20} />
                            <Typography>{language.name}</Typography>
                        </Stack>
                    </MenuItem>
                )
            })}
        </Select>
    ) : null;    
}

export default LanguageSelector;